import React from 'react';

/**
 * מעבד אירועי clipboard למניעת העתקה/הדבקה
 */
export const createClipboardEventHandler = () => (e: React.ClipboardEvent) => {
  e.preventDefault();
  return false;
};

/**
 * מעבד אירועי עכבר למניעת תפריט ימני, סימון וגרירה
 */
export const createMouseEventHandler = () => (e: React.MouseEvent) => {
  if (['contextmenu', 'mousedown', 'mouseup'].includes(e.type)) {
    e.preventDefault();
    return false;
  }
};

/**
 * יוצר props למניעת copy/paste אם נדרש
 */
export const createPreventionProps = (preventCopyPaste: boolean) => {
  if (!preventCopyPaste) return {};

  const clipboardHandler = createClipboardEventHandler();
  const mouseHandler = createMouseEventHandler();

  return {
    onCopy: clipboardHandler,
    onCut: clipboardHandler,
    onPaste: clipboardHandler,
    onContextMenu: mouseHandler,
    onMouseDown: mouseHandler,
    onMouseUp: mouseHandler,
  };
}; 